import { API, graphqlOperation } from "aws-amplify";
import { createLLMKnowledgeGraph } from "../graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { CreateLLMKnowledgeGraphInput, CreateLLMKnowledgeGraphMutation } from "../API";

export async function createLLMKnowledgeGraphAfterAdd(
  input: CreateLLMKnowledgeGraphInput
): Promise<GraphQLResult<CreateLLMKnowledgeGraphMutation>> {
  return API.graphql(
    graphqlOperation(createLLMKnowledgeGraph, {
      input: input,
    })
  ) as Promise<GraphQLResult<CreateLLMKnowledgeGraphMutation>>;
}
